// extracted by mini-css-extract-plugin
export default {"catalogSelect":"catalogSelect_catalogSelect__i3i14"};